import React, { type PropsWithChildren } from 'react';
import { VIEW_KIND_TREE } from '@jira/polaris__domain-view/src/viewKindTimeline.constants.tsx';
import { TreeViewTooltip } from './TreeViewTooltip.tsx';
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
import { fg } from '@atlassian/jira-feature-gating';

type Props = {
	viewKind: ViewKind;
};

export const ViewItemTooltip = ({
	viewKind,
	children,
}: PropsWithChildren<Props>): React.ReactNode => {
	if (viewKind === VIEW_KIND_TREE && fg('jpd_tree-view-standard-upgrade')) {
		return <TreeViewTooltip>{children}</TreeViewTooltip>;
	}

	return children;
};
